import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { NotACashGrabSection } from '../components/NotACashGrabSection';
import { ChillsSection } from '../components/ChillsSection';
import { WhatsInsideSection } from '../components/WhatsInsideSection';
import { SocialProofSection } from '../components/SocialProofSection';
import { PricingSection } from '../components/PricingSection';
import { AverageRatingSection } from '../components/AverageRatingSection';
import { TestimonialsGridSection } from '../components/TestimonialsGridSection';
import { UrgencySection } from '../components/UrgencySection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { SocialProofNotification } from '../components/SocialProofNotification';
export const LandingV1 = () => <div className="w-full min-h-screen bg-bttf-bg text-bttf-text" data-id="element-640">
    <Header data-id="element-641" />
    <main data-id="element-642">
      <HeroSection data-id="element-643" />
      <NotACashGrabSection data-id="element-644" />
      <ChillsSection data-id="element-645" />
      <WhatsInsideSection data-id="element-646" />
      <SocialProofSection data-id="element-647" />
      <PricingSection data-id="element-648" />
      <AverageRatingSection data-id="element-649" />
      <TestimonialsGridSection data-id="element-650" />
      <UrgencySection data-id="element-651" />
      <FAQSection data-id="element-652" />
    </main>
    <Footer data-id="element-653" />
    <SocialProofNotification data-id="element-654" />
  </div>;